import React from 'react';
import { useLanguage } from './LanguageContext';
import PrivavacyPolicySinhala from './PrivacyPolicySinhala';
import PrivacyPolicyEnglish from './PrivacyPolicyEnglish';
import Header from './Header';
import Footer from './Footer';

const PrivacyPolicy = () => {

    const { language } = useLanguage();

    return (
        <>
            <Header />
            {language === "sinhala" ? <PrivavacyPolicySinhala /> : <PrivacyPolicyEnglish />}
            <Footer />
        </>
    );
}

export default PrivacyPolicy;